import { WebSocketChannelClient } from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/WebSocketChannelClient";

// Receives incoming messages for a certain chat user
export default new WebSocketChannelClient("chat-user");
